import { useEffect, useRef, useState } from "react";
import { Mic2, Pause, Play, BadgeCheck } from "lucide-react";
import { BRAND_VOICE, BRAND_VOICES } from "@/lib/api";

/** Audition the palace script in three female voices; one sample plays at a time. */
export default function VoiceStudio({ onAudition, testid }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    const a = new Audio();
    a.preload = "none";
    a.onended = () => setPlaying(null);
    audioRef.current = a;
    return () => a.pause();
  }, []);

  const toggle = (v) => {
    const a = audioRef.current;
    if (playing === v.id) {
      a.pause();
      setPlaying(null);
      return;
    }
    onAudition?.();
    a.src = v.src;
    a.currentTime = 0;
    a.play().catch(() => setPlaying(null));
    setPlaying(v.id);
  };

  return (
    <div className="mt-2 rounded-xl border border-[#FF1E8C]/15 bg-[#061536]/70 p-3" data-testid={testid}>
      <p className="font-mono-lbl text-[10px] text-[#FF1E8C] uppercase tracking-widest flex items-center gap-1.5 mb-2">
        <Mic2 className="w-3.5 h-3.5" /> Brand Voice Studio · palace script, 3 female voices · tap to audition
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {BRAND_VOICES.map((v) => {
          const isBrand = v.id === BRAND_VOICE;
          const isPlaying = playing === v.id;
          return (
            <button
              key={v.id}
              type="button"
              onClick={() => toggle(v)}
              className={`text-left rounded-lg border px-3 py-2 flex items-center gap-2.5 transition-colors ${
                isBrand ? "border-[#00F0FF]/40 bg-[#00F0FF]/5" : "border-white/15 hover:border-white/40"
              }`}
              data-testid={`${testid}-${v.id}`}
              aria-pressed={isPlaying}
            >
              <span className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center ${isPlaying ? "bg-[#FF2E2E]" : "bg-white/10"}`}>
                {isPlaying ? <Pause className="w-3.5 h-3.5 text-white" /> : <Play className="w-3.5 h-3.5 text-white ml-0.5" />}
              </span>
              <span className="min-w-0">
                <span className="text-white text-xs font-semibold flex items-center gap-1">
                  {v.name}
                  {isBrand && (
                    <span className="inline-flex items-center gap-0.5 text-[#00F0FF] text-[10px] font-mono-lbl uppercase" data-testid={`${testid}-brand-badge`}>
                      <BadgeCheck className="w-3 h-3" /> Brand voice
                    </span>
                  )}
                </span>
                <span className="block text-white/55 text-[11px] truncate">{v.tone}</span>
                <span className="block text-[#00F0FF]/80 text-[10px] truncate" data-testid={`${testid}-${v.id}-films`}>Narrates: {v.films}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
